import { StreamData } from 'types/streamData'
import { FieldResolver } from './fieldResolver'
import { Metadata } from '../adaptor/metadata'
import {
  commentsResolver,
  engagementResolver,
  impressionsResolver,
  missDataResolver,
  negSentimentResolver,
  passionResolver,
  posSentimentResolver,
  likesResolver,
  reblogsResolver,
  scoreResolver,
  repliesResolver,
  retweetsResolver,
  sentimentsResolver,
  sharesResolver,
  viewsResolver
} from './metric'

const streamDataFieldResolvers: FieldResolver[] = [
  commentsResolver,
  engagementResolver,
  impressionsResolver,
  missDataResolver,
  negSentimentResolver,
  passionResolver,
  posSentimentResolver,
  likesResolver,
  reblogsResolver,
  scoreResolver,
  repliesResolver,
  retweetsResolver,
  sentimentsResolver,
  sharesResolver,
  viewsResolver
]

const metricRelatedFieldsResolver: FieldResolver = (metadata: Metadata) => {
  let result = {} as StreamData
  streamDataFieldResolvers.forEach((resolver) => {
    result = { ...result, ...resolver(metadata) }
  })

  return result
}

export default metricRelatedFieldsResolver
